// De records: de grootste losse verkoop die het dashboard ooit voorbij heeft
// zien komen, en daarnaast per verkoper zijn eigen grootste.
//
// De API geeft alleen totalen per verkoper, geen losse verkopen. Wat één
// verkoop was, weten we dus enkel doordat we twee metingen naast elkaar
// leggen (zie useSaleEvents). Het record bewaren we daarom hier, in de
// browser van de tv, zodat het een herstart of een nieuwe maand overleeft.

const storageKey = "td-sale-record";
const bestsKey = "td-seller-bests";

export function readRecord() {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;
    const record = JSON.parse(raw);
    return typeof record?.amount === "number" ? record : null;
  } catch (error) {
    // Privémodus of volle opslag: dan doen we het gewoon zonder record.
    return null;
  }
}

export function writeRecord(record) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(record));
  } catch (error) {
    /* niets aan te doen, en het mag het dashboard niet ophouden */
  }
}

export function clearRecord() {
  try {
    window.localStorage.removeItem(storageKey);
  } catch (error) {
    /* zie boven */
  }
}

// Per verkoper zijn grootste losse verkoop tot nu toe, als { naam: { amount,
// at } }. Dit loopt net als het record door over maanden heen: iemands beste
// verkoop wordt niet minder goed doordat de maand omslaat.
//
// Een naam die we niet kennen staat er niet in, en dat is het verschil
// tussen "hij heeft zijn record verbroken" en "dit is de eerste verkoop die
// wij van hem zien". Zonder dat onderscheid krijgt iedereen bij zijn eerste
// verkoop een kaart, en dat is geen record maar een kennismaking.
export function readBests() {
  try {
    const raw = window.localStorage.getItem(bestsKey);
    if (!raw) return {};
    const bests = JSON.parse(raw);
    return bests && typeof bests === "object" ? bests : {};
  } catch (error) {
    // Privémodus of volle opslag: dan doen we het zonder eigen records.
    return {};
  }
}

export function writeBests(bests) {
  try {
    window.localStorage.setItem(bestsKey, JSON.stringify(bests));
  } catch (error) {
    /* niets aan te doen, en het mag het dashboard niet ophouden */
  }
}

export function clearBests() {
  try {
    window.localStorage.removeItem(bestsKey);
  } catch (error) {
    /* zie boven */
  }
}
